import type * as TY                               from '../types/UtilityTypes.ts'

export function getLogger(_dna: any): TY.LoggerT {
  return console
}